import { Component, OnInit, ViewChild, Output, EventEmitter, Input, Self } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { ToastService, MdbCheckboxChange } from 'ng-uikit-pro-standard';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { DatesService } from 'src/app/shared/services/dates.service';
import { Subject } from 'rxjs';
import { CamionSucursalService } from 'src/app/services/camion-sucursal.service';
import { ChoferSucursalService } from 'src/app/services/chofer-sucursal.service';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { CamionChoferService } from 'src/app/services/camion-chofer.service';

@Component({
  selector: 'app-modal-add-edit-ruta',
  templateUrl: './modal-add-edit-ruta.component.html',
  styleUrls: ['../ruteador.component.scss'],
  providers: [SecurityService],
})
export class ModalAddEditRutasComponent implements OnInit {
  @ViewChild('verAddEditRutasModal', { static: true }) verAddEditRutasModal: ModalDirective;
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  formRuta: FormGroup;

  recorridoSeleccionado: any = null;
  optionsChofer: Array<any> = [];
  optionsCamion: Array<any> = [];

  //Variables
  public rutEmpresa;
  public sucursalCodigo;
  public latitudEmpresa;
  public longitudEmpresa;
  loading: boolean;
  camion: any = null;
  chofer: any = null;
  choferSeleccionado: number
  camionSeleccionado: string
  loadingCamiones: boolean = false;
  loadingChoferes: boolean = false;

  // Utils
  private log: any;
  private datosCargados: boolean = false;
  constructor(
    private fb: FormBuilder,
    private clog: ConsoleService,
    private accesolocalstorage: SecurityService,
    private recorridoService: RecorridoService,
    private messageRendererService: MessageRendererService,
    private choferSucursalService: ChoferSucursalService,
    private camionSucursalService: CamionSucursalService,
    private datesService: DatesService,
    private camionChoferService: CamionChoferService,
  ) {
    this.log = this.clog.log('RUTEADOR ADD EDIT');
  }

  ngOnInit() {
    this.createForm();
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa();
    this.sucursalCodigo = this.accesolocalstorage.getSucursalCodigo();
    this.latitudEmpresa = this.accesolocalstorage.getLatitudEmpresa();
    this.longitudEmpresa = this.accesolocalstorage.getLongitudEmpresa();
    // Cargar datos y establecer el estado de carga
    Promise.all([
      this.loadCamiones(),
      this.loadChofer()
    ]).then(() => {
      this.datosCargados = true;
    }).catch(error => {
      console.error('Error al cargar los datos:', error);
      this.messageRendererService.showErrors(['Error al cargar los datos necesarios.']);
    });
    this.formChangesSubscriptions();
  }

  formChangesSubscriptions() {
    this.formRuta.get("camion").valueChanges
      .subscribe((patente) => {
        if (!patente) {
          //this.formHeader.get('cantidad').setValue(0)
          return
        }
        this.loadChoferCamion(patente)
      })
  }

  private createForm() {
    this.formRuta = this.fb.group({
      chofer: [''],
      camion: [''],
      negocio: [''],
      nroDoc: [''],
      monto: [''],
      fechaMain: [null],
    });
  }

  loadCamiones(): Promise<void> {
    this.loadingCamiones = true;
    return new Promise((resolve, reject) => {
      this.camionSucursalService.obtenerCamionSucursalxRutEmpresaSucursal(
        {
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
          tipobusqueda: 1,
        },
        ({ respuesta, mensajes }) => {
          this.loadingCamiones = false;
          if (mensajes && mensajes.length > 0) {
            this.messageRendererService.showErrors(mensajes);
            reject(mensajes);
            return;
          }
          const { registros } = respuesta;
          this.optionsCamion = registros.map(({ patente, descripcion, ...rest }) => ({
            value: patente,
            label: `${patente} ${descripcion}`,
            ...rest,
          }));

          // Validar que recorridoSeleccionado no sea null y tenga patente
          if (this.recorridoSeleccionado && this.recorridoSeleccionado.patente) {
            const camionEncontrado = registros.find(c => c.patente === this.recorridoSeleccionado.patente);
            this.camionSeleccionado = camionEncontrado ? camionEncontrado.patente : null;
          } else {
            this.camionSeleccionado = null;
          }

          if (this.camionSeleccionado) {
            this.formRuta.get('camion').setValue(this.camionSeleccionado);
            this.setCamion();
          }
          resolve();
        }
      );
    });
  }

  loadChofer(): Promise<void> {
    this.loadingChoferes = true;
    return new Promise((resolve, reject) => {
      const inputParams = {
        entidad: {
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
          tipobusqueda: 1,
        },
      };
      this.choferSucursalService.obtenerchoferSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
        this.loadingChoferes = false;
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          reject(mensajes);
          return;
        }
        const { registros } = respuesta;
        this.optionsChofer = registros.map((p) => ({ value: p.rut, label: p.nombre, ...p }));
        resolve();
      });
    });
  }

  loadChoferCamion(cam: any) {
    const inputParams = {
      entidad: {
        patente: cam,
      },
    };
    this.camionChoferService.obtenerSegunPatente(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      this.choferSeleccionado = respuesta.rut_chofer;


      // Verificar si respuesta.rut_chofer es válido
      if (respuesta && respuesta.rut_chofer > 0) {
        this.formRuta.get('chofer').setValue(this.choferSeleccionado);
        this.setChofer()
      }


    });
  }

  showAdd() {
    const { currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.clearModal();
    this.formRuta.get('fechaMain').setValue(currentDate);
    this.verAddEditRutasModal.show();
  }

  async showEdit(cam: any) {
    console.log(cam);
    this.formRuta.get('fechaMain').setValue(cam.fecha);
    this.verAddEditRutasModal.show();

    this.recorridoSeleccionado = {
      checked: false,
      chofer_rut: cam.chofer_rut,
      fecha: cam.fecha,
      nombre_chofer: cam.nombre_chofer,
      patente: cam.patente,
      // index:    0
      recorrido_codigo: cam.recorrido_codigo,
      total_facturas: cam.total_facturas,
    };

    this.recorridoSeleccionado = cam;
    console.log('=>(ruteador.component.ts:185) this.recorridoSeleccionado', this.recorridoSeleccionado);
    if (this.recorridoSeleccionado && this.recorridoSeleccionado.patente && this.recorridoSeleccionado.chofer_rut) {
      this.formRuta.get('camion').setValue(this.recorridoSeleccionado.patente);
      this.formRuta.get('chofer').setValue(this.recorridoSeleccionado.chofer_rut);
      this.setCamion();
      this.setChofer();
    }
  }

  addRuta() {
    this.loading = true;
    const inputParams = {
      entidad: {
        codigo: this.recorridoSeleccionado ? this.recorridoSeleccionado.recorrido_codigo : null,
        chofer_rut: this.formRuta.get('chofer').value,
        camion_patente: this.camion.value,
        sucursal_codigo: this.sucursalCodigo,
        rut_empresa: this.rutEmpresa,
        limite_volumen: this.camion.volumen,
        limite_monto: 10000000,
        limite_peso: this.camion.peso_maximo,
        fecha_registro: this.formRuta.get('fechaMain').value,
        fecha: this.formRuta.get('fechaMain').value,
        activo: true,
        latitud_origen: this.latitudEmpresa,
        longitud_origen: this.longitudEmpresa,
      },
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.recorridoService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      const { empresa_rut } = respuesta;

      this.onSuccess.emit();
      // this.showSuccess('Operación Realizada');
      // this.postProcesoAddRuta();
      // this.buscarRecorridos();
    });
    this.loading = false;
    this.clearModal();
  }

  setChofer() {
    this.chofer = this.optionsChofer.filter((s) => s.value == this.formRuta.get('chofer').value)[0];
  }

  setCamion() {
    this.camion = this.optionsCamion.filter((s) => s.value == this.formRuta.get('camion').value)[0];
  }

  clearModal() {
    this.formRuta.reset();
    this.camion = null;
    this.chofer = null;
    this.recorridoSeleccionado = null;
  }

  CerrarModal() {
    this.clearModal();
    this.verAddEditRutasModal.hide();
  }
}
